import React, { useState, useEffect } from "react";

import de from "date-fns/locale/de";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { isValidDateObject } from "../../../functions/GlobalHelpers";

export default function CreditDateField(
  {
    fieldConfig,
    currentMetafields,
    hideChannels = false,
    channelDisplayNames,
    setMetafieldsValues,
  }) {

  const [value, setValue] = useState(null);

  useEffect(() => {
    const externalValue =
      currentMetafields[0].meta_value
        ? new Date(currentMetafields[0].meta_value)
        : null
      ;
    if (externalValue !== value) {
      setValue(externalValue);
    }
  }, [currentMetafields]);

  useEffect(() => {
    if (isValidDateObject(value)) {
      const externalValue =
        currentMetafields[0].meta_value
          ? new Date(currentMetafields[0].meta_value)
          : null
        ;
      if (externalValue !== value)
        setMetafieldsValues(currentMetafields, value);
    }
  }, [value]);

  if (!fieldConfig)
    return null;

  const helperText = hideChannels
    ? null
    : (currentMetafields.map((metafield, i) => channelDisplayNames[metafield.channel] + (i < currentMetafields.length - 1 ? ", " : "")));


  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
      <DatePicker
        key={currentMetafields[0].id}
        fullWidth
        disableToolbar
        variant="inline"
        format="dd.MM.yyyy"
        openTo="year"
        margin="none"
        label={fieldConfig.label}
        helperText={helperText}
        value={value ? value : null}
        onChange={(value) => {
          setValue(value);
        }}
        onBlur={() => {
          // force rerender to make sure placeholders using the value of this field are updated
          setMetafieldsValues(currentMetafields, value, true);
        }}
        autoOk={true}
        invalidDateMessage={"ungültiges Datumsformat"}
        InputLabelProps={{
          shrink: true,
        }}
        slotProps={{
          textField: {
            variant: 'standard',
          },
        }}
      />
    </LocalizationProvider>
  );
}
